import React from "react";
import { challenges } from "../mock";

export default function Challenge() {
  return (
    <section className="section-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="eyebrow eyebrow-line">Why owners engage us</p>
            <h2 className="font-serif-display mt-6 text-[2.1rem] md:text-[3rem] leading-[1.05] text-[#2a3325]">
              Property abroad is <span className="italic-accent">seldom</span> passive.
            </h2>
            <p className="mt-6 text-[#4d5a45] leading-relaxed max-w-md">
              The gap between an owner and a Tier-1 asset is built into the market, not accidental. Our role is to close that gap with a clean, accountable engagement — documented from the first call.
            </p>
          </div>
          <div className="lg:col-span-7 lg:pl-10 lg:border-l border-[#c4cfb2]">
            <ul>
              {challenges.map((c, i) => (
                <li key={c.n} className={`py-6 ${i !== challenges.length - 1 ? "border-b border-[#c4cfb2]" : ""}`}>
                  <div className="flex gap-8">
                    <span className="font-serif-display italic-accent text-lg pt-1">{c.n}</span>
                    <div>
                      <h3 className="font-serif-display text-2xl text-[#2a3325]">{c.title}</h3>
                      <p className="mt-2 text-[#4d5a45] leading-relaxed">{c.desc}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
